<template>
	<v-layout wrap class="section-plan">
		<v-flex xs12 text-xs-center mb-4>
			<img src="/static/images-new/sections/logo-japi.svg" alt="logo japi">
		</v-flex>
		<v-flex xs12 class="subtitle" mb-5>
			<p>
				<span class="bold text-blue">Japisale</span> 
				se renueva! En Alianza con <span class="bold">CasaMarket</span> ofrece una solución integral para tu empresa: 
				<span class="bold text-blue">Sistema de Gestión Integrado + Venta Online</span>
			</p>
			<p>Escala Tu Negocio con nuestros Productos de Gestión y Venta</p>
		</v-flex>
		<v-flex>
			<v-layout justify-center mb-2 class="group-arrow">
				<v-flex xs3 text-xs-center>
					<img src="/static/images-new/sections/arrow-yellow.svg" alt="flecha">
				</v-flex>
				<v-flex xs3 text-xs-center>
					<img src="/static/images-new/sections/arrow-yellow.svg" alt="flecha">
				</v-flex>
			</v-layout>
			<v-layout justify-center wrap>
				<v-flex xs12 md3 v-for="item in items" :key="item.id" px-3 mb-3>
					<div class="group-title mb-3">
						<p class="mb-2 f-14">{{ item.name }}</p>
						<p class="mb-0 text-price bold">{{ item.price }}</p>
					</div>
					<div class="group-text">
						<div class="text-number mb-3">{{ item.id }}</div>
						<p>{{ item.subtitle }}</p>
						<div>
							<div v-for="list in item.list" :key="list" class="layout mb-2">
								<img 
									src="/static/images-new/icons/check-orange.svg" 
									alt="check" 
									height="14px"
									class="mr-2"
								>
								<span>{{ list }}</span>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 text-xs-center mt-5>
			<a :href="whatsappLink" target="_blank" class="href-depressed">
				<button class="href-wssp w-bold">
					<v-layout align-center>
						<v-flex xs2>
							<img src="/static/images-new/icons/whatsapp-white.svg" alt="">
						</v-flex>
						<v-flex class="ml-1 text-wssp" text-xs-left>
							Deseo más información
						</v-flex>
					</v-layout>
				</button>
			</a>
		</v-flex>
	</v-layout>
</template>
<script>
function whatsappLink() {
	const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	if (reg.test(navigator.userAgent)) {
		return `https://api.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER}`;
	}
	return `https://web.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER}`;
}

function data() {
	return {
		items: [
			{
				id: 1,
				name: 'PLAN DESEGUE',
				price: 'Desde S/35 al mes',
				subtitle: 'Primer paso para iniciar tu viaje digital:',
				list: [
					'Tienda Online que te permite recibir pedidos por WhatsApp',
					'Facturación Electrónica',
					'Medios de Pago Online',
				],
			},
			{
				id: 2,
				name: 'PLAN EMPRENDEDOR',
				price: 'Desde S/75 al mes',
				subtitle: 'Segundo Paso, para escalar tu empresa:',
				list: [
					'500 Productos en tu catálogo',
					'Tienda Online con Facebook Live',
					'SEO',
					'Control de Stock y Kardex',
					'2 Tiendas Físicas',
					'Cupones de descuento',
				],
			},
			{
				id: 3,
				name: 'PLAN PRO',
				price: 'Desde S/149 al mes',
				subtitle: 'Tercer Paso, da el salto al mundo de las ventas por mobile:',
				list: [
					'App de Pedidos Personalizada',
					'Ecommerce Web',
					'Reseñas de clientes',
					'Módulo de Caja y Tesorería',
					'Rutas de Distribución para Delivery',
				],
			},
		],
	};
}

export default {
	data,
	name: 'section-plan',
	computed: {
		whatsappLink,
	},
};
</script>
<style lang="scss" scoped>
	.section-plan {
		background-image: linear-gradient(to bottom, rgba(231, 240, 244, 1), #f8fbfc 68%);
		font-size: 18px;
		padding: 130px 4% 60px;

		@media (max-width: 936px) {
			padding: 45px 4%;
		}
	}

	.bold {
		font-weight: 700;
	}

	.text-blue {
		color: color(blue-japi);
	}

	.subtitle {
		color: color(newwarning);
		font-size: 16px;
		padding: 0 20%;
		text-align: center;

		@media (max-width: 936px) {
			padding: 0 4%;
		}
	}

	.group-title {
		border: 2px solid color(blue-japi);
		border-radius: 15px;
		color: color(blue-japi);
		padding: 15px 0;
		text-align: center;
		margin: 0 auto;
		width: 85%;

		@media (max-width: 936px) {
			margin: 0 auto 17px auto;
			width: 60%;
		}
	}

	.f-14 {
		font-size: 14px;
	}

	.text-price {
		color: color(yellow-japi)
	}

	.group-text {
		background-color: color(white);
		border: solid 3px color(newbackground);
		border-radius: 12px;
		font-size: 14px;
		height: calc(100% - 100px);
		padding: 19px;

		@media (max-width: 936px) {
			margin: 0 auto;
			width: 80%;
		}
	}

	.text-number {
		align-items: center;
		background-color: color(blue-japi);
		border-radius: 50%;
		color: color(white);
		display: flex;
		font-size: 24px;
		font-weight: 700;
		justify-content: center;
		height: 58px;
		margin: 0 auto;
		width: 58px;
	}

	.href-wssp {
		background: #64b161;
		border-radius: 26px;
		box-shadow: 0 2px 6px 0 rgba(158, 158, 158, 0.5);
		color: map-get($colors, white);
		padding: 9px 9px 9px 22px;
		text-decoration: none;
		width: 282px;
	}

	.group-arrow {
		@media (max-width: 936px) {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/japi-sale/section-plan.vue